/** Bridge Quick Setup vehicle step to shared admin category filter config. */

import { getFilterFieldKeys } from '@/utils/searchCategoryConfig';
import { EMPTY_SEARCH_FORM, type SearchAdminFormState } from '@/utils/searchAdminForm';
import type { QuickSetupFormState } from './types';

const VEHICLE_FILTER_KEYS = getFilterFieldKeys('vehicles');

export function quickSetupToVehicleAdminForm(form: QuickSetupFormState): SearchAdminFormState {
  return {
    ...EMPTY_SEARCH_FORM,
    category: 'vehicles',
    source_names: form.source_names,
    search_text: form.search_text,
    brand: form.brand,
    model: form.model,
    year_min: form.year_min,
    year_max: form.year_max,
    price_min: form.price_min,
    price_max: form.price_max,
    mileage_min: form.mileage_min,
    mileage_max: form.mileage_max,
    fuel: form.fuel,
    transmission: form.transmission,
    message_templates: form.message_templates,
  };
}

export function vehicleAdminPatchToQuickSetup(
  patch: Partial<SearchAdminFormState>,
): Partial<QuickSetupFormState> {
  const out: Partial<QuickSetupFormState> = {};
  for (const key of VEHICLE_FILTER_KEYS) {
    if (key in patch) {
      (out as Record<string, string>)[key] = String(patch[key as keyof SearchAdminFormState] ?? '');
    }
  }
  return out;
}
